import React from "react";
import { Box, TextField, Button, InputAdornment, Typography } from "@material-ui/core";
import { modal } from "../../../util";
import styled from "styled-components";

const A = styled.a`
  color: #306F9D;
  text-decoration: none;
`;

const ImageUploadField = ({
    field,
    value,
    onUpload,
    onDelete,
    label,
    required = false,
    error = null,
    classes = {},
    placeholder = null,
}) => {
    const imageValue = value || "";
    const defaultPlaceholder = imageValue ? "Change image" : "Upload image";
    const finalPlaceholder = placeholder || defaultPlaceholder;

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            onUpload(field, file);
        }
        // Reset input value to allow selecting the same file again
        e.target.value = "";
    };

    const handleDelete = async () => {
        const decision = await modal.fire({
            title: "Delete Image",
            text: "Are you sure to delete this image?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            onDelete(field);
        }
    };

    return (
        <Box className={classes.formField}>
            {label && (
                <Typography variant="body2" className={classes.sectionText} style={{ marginBottom: "8px" }}>
                    {label}
                </Typography>
            )}
            <TextField
                htmlFor={`file-upload-${field}`}
                className={classes.fileInput}
                value=""
                variant="outlined"
                placeholder={finalPlaceholder}
                fullWidth
                InputProps={{
                    classes: {
                        input: classes["&::placeholder"],
                    },
                    endAdornment: (
                        <InputAdornment position="end">
                            <input
                                style={{ display: "none" }}
                                id={`file-upload-${field}`}
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                            <Button
                                htmlFor={`file-upload-${field}`}
                                variant="outlined"
                                component="label"
                                size="small"
                            >
                                Choose
                            </Button>
                        </InputAdornment>
                    ),
                }}
                style={imageValue ? { marginBottom: "0" } : {}}
                error={required && !imageValue && !!error}
                helperText={required && !imageValue && error ? error : ""}
            />
            {imageValue && (
                <Box style={{ marginTop: "8px" }}>
                    <img
                        src={imageValue}
                        style={{
                            maxHeight: "30px",
                            maxWidth: "30px",
                            cursor: "pointer"
                        }}
                        alt=""
                        onError={(e) => {
                            // Hide image if it fails to load
                            e.target.style.display = "none";
                        }}
                        onClick={() => {
                            if (imageValue) {
                                window.open(imageValue, '_blank').focus();
                            }
                        }}
                    />
                    &nbsp;
                    <A href={imageValue} target="_blank">
                        <small>{imageValue.split("/").pop()}</small>
                    </A>
                    <small
                        style={{
                            marginLeft: "20px",
                            textDecoration: "underline",
                            color: "#962013",
                            cursor: "pointer",
                        }}
                        onClick={handleDelete}
                    >
                        Delete
                    </small>
                </Box>
            )}
        </Box>
    );
};

export default ImageUploadField;

